import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild} from '@angular/core';
import { LineType, PlantListService, SubLineType } from '../../services/plant-list.service'
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable, of, Subscription} from 'rxjs';
import { AssetListStorageService } from '../../services/asset-list-storage.service';
import { GetTaskListService } from '../../services/get-task-list.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { CdkVirtualScrollViewport, CdkScrollable, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from "@angular/cdk/scrolling";
import { MatSelect, MatOption } from "@angular/material/select";
import { EamLookupDialog, EAMLookupData } from "./eam-lookup-dialog";
import { MatDialog } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { NgFor, NgIf, NgStyle, AsyncPipe } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDivider } from '@angular/material/list';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export type assetInfo = {
  assetname: string,
  descript: string
}

export type EAMAsset = {
  AssetNumber:string,
  Description:string,
  Maintainable_flag:string
}


@Component({
    selector: 'create-object-dialog',
    templateUrl: './create-object-dialog.html',
    styleUrls: ['./create-object-dialog.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, NgFor, MatOption, MatCheckbox, MatInput, CdkTextareaAutosize, NgIf, MatProgressSpinner, MatDivider, MatAutocompleteTrigger, MatAutocomplete, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NgStyle, MatButton, MatIcon, MatDialogActions, AsyncPipe]
})
export class CreateObjectDialog implements OnInit{

    @ViewChild(CdkVirtualScrollViewport, { static: false })
    cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
    @ViewChild(MatSelect, { static: true }) matSelect: MatSelect;

    title:string;
    disable: boolean;
    assetList: any[];
    filteredOptions: Observable<any>;
    selectedSite: string;
    selectedLineID: number;
    assetListLoaded: boolean;
    assetListLoading:boolean=false;
    data: DialogData;
    showAutoComplete:boolean=false;
    showInvalidAsset:boolean=false;
    lookupAsset:string;
    lookupAssetSite:string;
    lineOverride:boolean; // TEMPORARY, will remove with ITMFG-44979

    eamAssets:BehaviorSubject<any> = new BehaviorSubject({});
    plantList:any;
    
    lineList:LineType[];
    lineListFiltered:LineType[];
    subLineList:SubLineType[];
    subLineListFiltered:SubLineType[];

    objCreateFormGroup: UntypedFormGroup;

    isTablet$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])
    isScreen$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
  
    workRequestTypeList:any[] = [{'display_type':'Not Required','type':0},{'display_type':'All Issue Found (NOK)','type':1},{'display_type':'Safety Inspection Issue Found (NOK)','type':2}];

    constructor(
      public dialogRef: MatDialogRef<CreateObjectDialog>,
      private plantListService: PlantListService,
      @Inject(MAT_DIALOG_DATA) public inData: DialogData,
      private fb: UntypedFormBuilder,
      private _snackBar: MatSnackBar,
      private adminService: GetTaskListService,
      private breakpointObserver: BreakpointObserver,
      private assetListStorageService: AssetListStorageService,
      private dialog:MatDialog)
       {
        this.assetListLoaded = true
        this.data = inData['objData'];
        
        this.data.loadtime = this.data.loadtime ? this.data.loadtime : 120;

        
        let requireComment_checked: boolean;
        requireComment_checked = this.data.requirecomment == 1 ? true : false;

        let optionalComment_checked: boolean;
        optionalComment_checked = this.data.requirecomment == 2 ? true : false;

        let requireWorkRequest: Number;
        requireWorkRequest = !Number.isNaN(Number(this.data.requireworkrequest)) ? this.data.requireworkrequest : 0;

        let defaultEAMAsset_checked: boolean;
        defaultEAMAsset_checked = this.data.defaulteamasset == 1 ? true : false;

        let manualLoad_checked: boolean;
        manualLoad_checked = this.data.manualLoad == 1 ? true : false;

        this.selectedSite = this.data.display_name
        
        if (this.data.isEdit) {
          this.title = "Edit Object";
        } else {
          this.title = "Create Object";
        }

        this.plantListService.lineList().subscribe((
          out => {
            this.lineList = out.Body.Lines;
            this.subLineList = out.Body.SubLines;
            this.filterLines();
          }
        ))
        
        this.plantListService.plantList().subscribe((
          out => {
            this.plantList = out.Body;
            if(this.data.isEdit) {
              this.select();
            }             
          }
        ));
        this.disable = this.data.isEdit;

        if (this.data.isEdit && this.data.lineID == -1 && this.inData.section != "") {
          this.lineOverride = true;
        } else {
          this.lineOverride = false;
        }

        this.objCreateFormGroup = this.fb.group({
          display_name: new UntypedFormControl(
            {value: this.data.display_name, disabled: this.disable}, Validators.required),
          line: new UntypedFormControl(
            {value: this.data.lineID, disabled: false}, Validators.required),
          subline: new UntypedFormControl(
            {value: this.data.subLineID, disabled: false}, Validators.required),
          line_override: new UntypedFormControl(
            {value: this.lineOverride, disabled: false}),
          section: new UntypedFormControl(
            {value: this.data.section, disabled: false}, Validators.required),
          subsection: new UntypedFormControl(
            {value: this.data.subsection, disabled: false}),
          objectID: new UntypedFormControl(
            {value: this.data.objectid, disabled: this.disable}, Validators.required),
          manualDescript: new UntypedFormControl(
            {value: this.data.manualDescription, disabled: false}, Validators.required),
          assetNum: new UntypedFormControl(
            {value: this.data.eam_asset, disabled: false}),
          loadtime: new UntypedFormControl(
            {value: this.data.loadtime, disabled: false}, [Validators.required, Validators.pattern('[0-9]*')]),
          manualLoad: new UntypedFormControl(
            {value: manualLoad_checked, disabled: false}),
          requireComment: new UntypedFormControl(
            {value: requireComment_checked, disabled: false}),
          optionalComment: new UntypedFormControl(
            {value: optionalComment_checked, disabled: false}),
          requireWorkRequest: new UntypedFormControl(
            {value: requireWorkRequest, disabled: false}, Validators.required),
          defaultEAMAsset: new UntypedFormControl(
            {value: defaultEAMAsset_checked, disabled: false})
        });

        if (this.objCreateFormGroup.get('requireComment')?.value){
          this.objCreateFormGroup.get('optionalComment')?.disable()
        }

        if (this.objCreateFormGroup.get('optionalComment')?.value){
          this.objCreateFormGroup.get('requireComment')?.disable()
        }
        
        this.objCreateFormGroup.get('requireComment')?.valueChanges.subscribe(value => {
          if (value){
            this.objCreateFormGroup.get('optionalComment')?.disable()
          } else {
            this.objCreateFormGroup.get('optionalComment')?.enable()
          }
        })

        this.objCreateFormGroup.get('optionalComment')?.valueChanges.subscribe(value => {
          if (value){
            this.objCreateFormGroup.get('requireComment')?.disable()
          } else {
            this.objCreateFormGroup.get('requireComment')?.enable()
          }
        })
      }


      
    ngOnInit(){
      this.filteredOptions = this.eamAssets.asObservable();

      this.objCreateFormGroup.controls['assetNum'].valueChanges.subscribe(value => {
        console.debug("valuechanged", value);
        this.filter(value);
      });


      this.assetListStorageService.eamAssetObservable.subscribe((assets) => {
        console.debug("ASSET LIST RECEIVED!!", assets);
        let assetArr: any = assets
        this.assetList = assetArr
        if (this.assetList[this.selectedSite]) {
          this.assetListLoading = false;
        }
      })
    }

    private filter(value:string) {
      let output:EAMAsset[] = [];

      if (this.assetList[this.selectedSite]){
        output = this.assetList[this.selectedSite].filter(function (option) {
          return option.AssetNumber.toLowerCase().includes(value.toLowerCase())
        });
      }
      
      if (output.length == 0) {
        this.showAutoComplete = false;
      } else {
        this.showAutoComplete = true;
      }
     
      this.eamAssets.next(output);
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

    select() {
      const d = this.objCreateFormGroup.getRawValue().display_name;
      console.debug("Site Selected", d);
      this.selectedSite = d;

      if (this.selectedSite != undefined) {
        if (this.selectedSite != "") {
          this.filterLines();
          if (this.assetList != undefined && this.assetList[this.selectedSite]) {
            this.assetListLoading = false;
          } else {
            this.assetListLoading = true;
            this.assetListStorageService.updateAssetList(this.selectedSite);
          }
        }
      }
    }

    filterLines() {
      if (this.selectedSite && this.lineList != undefined) {
        this.lineListFiltered = this.lineList.filter((line) => line.display_name == this.selectedSite);
        this.selectLine();
      }
    }

    selectLine() {
      const d = this.objCreateFormGroup.getRawValue().line;
      console.debug("Line", d);
      this.selectedLineID = d;

      if (this.selectedLineID != undefined && this.selectedLineID != -1) {
        this.subLineListFiltered = this.subLineList.filter((subline) => subline.line_id == this.selectedLineID);
        this.subLineListFiltered.unshift({line_id: this.selectedLineID, subline_id: -1, subline: "<None>" });

        // Set Section - Will be removed with ITMFG-44979 when override is removed
        let lineDesc = this.lineList.filter((line) => line.line_id == this.selectedLineID)[0]['line'];
        console.log("LineDesc", lineDesc);
        this.objCreateFormGroup.patchValue({ section: lineDesc, subsection: '' });

      } else {
        this.subLineListFiltered = [];
      }
    }

    /**
     * TEMPORARY: WILL REMOVE WITH ITMFG-44979
     */
    selectSubLine() {
      const d = this.objCreateFormGroup.getRawValue().subline;
      console.debug("SubLine", d);
      let subLineID:number = d;

      if (subLineID != -1) {
        let subLineDesc = this.subLineList.filter((subline) => subline.subline_id == subLineID)[0]['subline'];
        console.log("LineDesc", subLineDesc);
        this.objCreateFormGroup.patchValue({ subsection: subLineDesc });
      } 
    }

    /**
     * TEMPORARY: WILL REMOVE WITH ITMFG-44979
     */
    selectOverride() {
      const d = this.objCreateFormGroup.getRawValue().line_override;
      this.lineOverride = d;

      if (this.lineOverride) {
        this.objCreateFormGroup.patchValue({ line: -1, subline: -1, section: '', subsection: '' });

        this.selectLine();
      }
    }

    duplicateCheck(){
      const d = this.objCreateFormGroup.getRawValue();
      let newObjectID = d.objectID.toUpperCase();
      console.log("OBJS", this.inData['objs'])
      console.log("d", d);

      let objects = this.inData['objs'].filter(x => x.objectID === newObjectID);

      if (objects && objects.length > 0) {
        return true;
      } else {
        return false;
      }
    }

    validateAsset(asset:string):boolean {
      let result:boolean = false;
      
      if (asset == this.data.eam_asset || asset == "") {
        result = true; // Original asset, no changes
      } else if (this.lookupAsset == asset) {
        result = true; // Validated from the lookup
      } else {
        let assetList = this.assetList[this.selectedSite].filter(function (option) {
          return option.AssetNumber.toLowerCase().includes(asset.toLowerCase())
        });
  
        if (assetList.length == 1) {
          result = true;
        } else if (assetList.length > 1) {
          assetList.forEach(function (value) {
            if (value.AssetNumber == asset) {
              result = true;
            }
          })
        } else {
          result = false;
        }
      }
  
      return result;
    }
    
    saveData(): void {
      console.log("Save Data", this.objCreateFormGroup)
      let bClose:boolean = true;
      let loadtime: number;
      let requireComment: number;
      let requireWorkRequest: number;
      let defaultEAMAsset: number;
      let manualLoad: number;


      let rawFormData = this.objCreateFormGroup.getRawValue();
      loadtime = rawFormData.loadtime;
      manualLoad = rawFormData.manualLoad ? 1 : 0;
      console.log('Raw Form Data: ', rawFormData)
      requireComment = rawFormData.requireComment ? 1 : (rawFormData.optionalComment ? 2 : 0);
      requireWorkRequest = rawFormData.requireWorkRequest;
      defaultEAMAsset = rawFormData.defaultEAMAsset ? 1 : 0;
      console.log("requireComment", requireComment);
      const formData = {DisplayName: this.data.display_name, lineID: rawFormData.line, subLineID: rawFormData.subline, objectid: rawFormData.objectID, section: rawFormData.section, subsection: rawFormData.subsection, manualDescription: rawFormData.manualDescript, LoadTime: loadtime, ManualLoad: manualLoad, RequireComment: requireComment, RequireWorkRequest:requireWorkRequest, DefaultEAMAsset: defaultEAMAsset, EAMAsset: rawFormData.assetNum}
      if ( (formData.section == '' || formData.section == null) ||  (formData.objectid == '' || formData.objectid == null) ||  (formData.manualDescription == '' || formData.manualDescription == null) ||  (formData.RequireWorkRequest == undefined || Number.isNaN(Number(formData.RequireWorkRequest)))){
        bClose = false;
        this._snackBar.openFromComponent(CreateObjErrorSnackBar, {
          duration: 5000,
          data: "All fields are required"
        });
      } else if (!this.validateAsset(formData.EAMAsset)) {
        this.showInvalidAsset = true;
        bClose = false;
      } else if (!this.data.isEdit) {
        let dupCheck = this.duplicateCheck()
        if (dupCheck == true) {
          console.log("duplicate check")
          bClose = false;
          this._snackBar.openFromComponent(CreateObjErrorSnackBar, {
            duration: 5000,
            data: "This object already exists"
          });
        } 
      } 
      
      if (bClose) {
          let subSection = "";
          console.log(rawFormData.subsection);
          if (rawFormData.subsection == undefined) {
            subSection = "";
          } else {
            subSection = rawFormData.subsection
          }
          this.adminService.editObject(rawFormData.display_name, rawFormData.line,  rawFormData.subline, rawFormData.objectID, rawFormData.section, subSection, rawFormData.manualDescript, rawFormData.assetNum, loadtime, manualLoad, requireComment, requireWorkRequest, defaultEAMAsset).subscribe((
            out => {
              this.dialogRef.close(rawFormData.display_name); 
            }))
      }
    }

    openEAMLookup() {
      const eamAsset:string = this.objCreateFormGroup.getRawValue().assetNum;;
      let site:string;

      if (this.lookupAssetSite != "") {
        site = this.lookupAssetSite;
      } else {
        site = this.selectedSite;
      }

      const dialogRef = this.dialog.open(EamLookupDialog, {
        width: '800px',
        maxHeight: '800px',
        data: {
          "display_name": site,
          "eam_asset": eamAsset
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined && result != "") {
          this.objCreateFormGroup.patchValue({"assetNum": result.eam_asset});
          this.lookupAssetSite = result.display_name;
          this.lookupAsset = result.eam_asset;
        }
      });
    }
}
  
  export interface DialogData {
    isEdit: boolean;
    display_name: string;
    section: string;
    subsection: string;
    lineID: number;
    subLineID: number;
    objectid: string;
    manualDescription: string;
    eam_asset: string;
    loadtime: number;
    manualLoad: number;
    requirecomment: number;
    requireworkrequest: number;
    defaulteamasset: number;
  }

  @Component({
    selector: 'ErrorSnackBarCreate',
    template: "<span style='color: yellow'>{{data}}</span>",
    styles: []
})
  export class CreateObjErrorSnackBar {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
  }